export default __webpack_public_path__ + "static/media/award-winning-000000.daf2226c.png";